import vuetifyToast from 'vuetify-toast'
import { baseActions, baseMutations } from '../base'
import { apiAxios } from '@/helpers'
import { formatDate } from '@/helpers/dateHelper'
const notify = (message, type) => {
  vuetifyToast.show({
    text: message,
    color: type || 'success',
    timeout: 3000,
    icon: 'check',
  })
}
const initialState = () => {
  return {
    module: 'events',
    model: 'event',
    loading: false,
    list: [],
    selected: {},
    idSelected: '',
    pagination: {
      hasMore: false,
      page: 1,
      rowsPerPage: 0,
      totalItems: 0,
    },
  }
}

const state = initialState()

const getters = {
  selectList(state) {
    return state.list.map((item) => {
      let result = { value: item._id, text: item.name }

      result.icon = item.icon ? process.env.VUE_APP_IMAGE_URL + item.icon : ''
      return result
    })
  },
  formatedList(state) {
    return state.list.map((item) => {
      let result = {
        _id: item._id,
        team: item.teamId ? item.teamId.name : '',

        player: item.playerId
          ? item.playerId.name + ' ' + item.playerId.lastname1
          : '',
        typeEvent: item.typeEventId ? item.typeEventId.name : '',
        typeEventId: item.typeEventId ? item.typeEventId.id : '',
        minute: Number(item.minute) || 0,
        second: Number(item.second) || 0,
        fromVideoStart: Number(item.fromVideoStart) || 0,
        votesAverage: item.votesAverage,
        createdAt: formatDate(item.createdAt, true),
        createdBy: item.createdBy
          ? item.createdBy.name + ' ' + item.createdBy.lastname1
          : '-',
      }

      if (item.teamId) {
        let logo = item.teamId.logo
        if (item.teamId.entityId && item.teamId.entityId.logo) {
          logo = item.teamId.entityId.logo
        }
        if (logo.includes('http')) {
          result.teamLogo = logo
        } else {
          result.teamLogo = process.env.VUE_APP_IMAGE_URL + logo
        }
      }
      if (item.icon) {
        if (item.icon.includes('http')) result.icon = item.icon
        else result.icon = process.env.VUE_APP_IMAGE_URL + item.icon
      }
      if (item.typeEventId && item.typeEventId.icon) {
        if (item.typeEventId.icon.includes('http')) {
          result.eventIcon = item.typeEventId.icon
        } else {
          result.eventIcon =
            process.env.VUE_APP_IMAGE_URL + item.typeEventId.icon
        }
      }

      return result
    })
  },
}

const actions = {
  ...baseActions,
  async fetchList({ commit, state }, params = {}) {
    let query = {
      page: state.pagination.page,
      limit: state.pagination.rowsPerPage,
    }
    let body = Object.assign({}, params)
    if (body.limit !== undefined) {
      query.limit = body.limit
      delete body.limit
    }
    if (body.page) {
      query.page = body.page
      delete body.page
    }

    // if (rootState.matches.idSelected) {
    //   body.matchId = rootState.matches.idSelected
    //   dispatch('matches/fetchList', {}, { root: 1 })
    // } else if (rootState.trainings.idSelected) {
    //   body.trainingId = rootState.trainings.idSelected
    //   dispatch('trainings/fetchList', {}, { root: 1 })
    // }
    commit('setLoading', true)
    const { data } = await apiAxios
      .post(state.module, body, { params: query })
      .finally(() => commit('setLoading', false))
    const list = data.data
      ? data.data[state.model] || data.data[state.module]
      : []
    commit('setList', list)
  },
  async create({ dispatch, commit, state }, payload) {
    commit('setLoading', true)
    const { data } = await apiAxios
      .post(state.module + '/create', payload)
      .finally(() => commit('setLoading', false))
    notify(data.message)
    if (payload.matchId) {
      dispatch('matches/fetchOne', payload.matchId, { root: true })
    } else if (payload.trainingId) {
      dispatch('trainings/fetchOne', payload.trainingId, { root: true })
    } else {
      dispatch('fetchList')
    }
    const item = data.data ? data.data[state.model] : {}
    return item
  },
}

const mutations = {
  ...baseMutations,
  resetState(state) {
    const newState = initialState()
    Object.keys(state).forEach((key) => {
      delete state[key]
    })
    Object.assign(state, newState)
  },
  reset(state) {
    state.selected = initialState().selected
    state.idSelected = ''
  },
}

export default {
  namespaced: true,
  state,
  actions,
  mutations,
  getters,
}
